/**
 * The browser tab's title. index.html starts the app as "Brush Room"; once a room is open the tab names it too —
 * "Seminole Hard Rock Hollywood · Brush Room" — so where you are is said even with the Rundown rail hidden to its handle
 * (walk feedback on #575, 2026-10-30) and among several tabs.
 */
export const APP_TITLE = 'Brush Room';

export function roomDocumentTitle(name?: string | null): string {
  const room = name?.trim();
  return room ? `${room} · ${APP_TITLE}` : APP_TITLE;
}
